import { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { AuthContext } from '../../../../core/contexts/AuthContext'
import { Login } from '../../../../core/models/login/login'
import { LoginService } from '../../../../core/services/login/login.service'
import LoginForm from './LoginForm'
import { useIdentityStore, useSnackbarStore, useUIStore } from '../../../../core/store'
import logoAPP from "../../../../core/assets/img/logo.png"
import clsx from 'clsx'
import { Divider } from '../../../components'
import { COLORS } from '../../../../core/constants/colors'
import { BASE_ROUTE, useLocalizedRoutes } from '../../../../core/constants/route_name'





const image = false


const LoginPage = () => {

  const ROUTE_NAME = useLocalizedRoutes();

  const navigate = useNavigate();
  const { checkIdentity } = useContext(AuthContext);

  const { setIdentity } = useIdentityStore(state => state);

  const [loadingButton, setLoadingButton] = useState(false);
  const [error, setError] = useState(false);

  const { setUI } = useUIStore(state => state)


  const { addSnackbar, setMaxSnackbars } = useSnackbarStore();





  useEffect(() => {
    localStorage.removeItem("identity");
    localStorage.removeItem("token");
    localStorage.removeItem("_c");
    localStorage.removeItem("_cal")

    setUI({ asideShow: false })

    // localStorage.clear();
    // handleLogin();
  }, [])

  const handleLogin = async () => {
    try {
      if (!localStorage.getItem('reloaded')) {
        localStorage.setItem('reloaded', 'true');
        window.location.reload();
      } else {
        localStorage.clear();
      }
    } catch (error) {
      console.error(error)
    }
  };


  const access = (values: Login) => {

    console.log(values);

    return new Promise<any>((res, rej) => {


      setError(false);
      console.log("que es values", values)
      // handleLoading(true);
      setLoadingButton(true);
      LoginService.login(
        {
          email: values.email,
          password: values.password,
        }
      )
        .then(async ({ data }) => {
          console.log(data);


          if (data.ok) {
            if (data.item?.user) {
              console.log("que llega aqui?222")
              console.log(data.item?.user)
              setIdentity(data.item.user);
              // const encode = DataBasicEncoder.encode(data.item.user);
              // localStorage.setItem("identity", encode)

              await checkIdentity();


              setMaxSnackbars(1);

              addSnackbar({

                duration: 1500,
                title: "Inicio de sesión exitoso",
                position: "bottom-center",
                color: "success",
              })

              setMaxSnackbars(3);



              setLoadingButton(false);
              if (data.item?.user?.role === "ROLE_ADMIN" || data.item?.user?.role === "ROLE_DEVELOPER") {
                navigate(`${BASE_ROUTE}${ROUTE_NAME.sponsor}`);
              } else {
                navigate(`${BASE_ROUTE}${ROUTE_NAME.sponsor}`);

              }
            } else {
              // handleLoading(false);
              setLoadingButton(false);

              throw new Error("Error desde response.ok", data);
            }
          } else {
            // handleLoading(false);
            setLoadingButton(false);

          }
        })
        .catch(e => {
          // handleLoading(false);
          setLoadingButton(false);
          addSnackbar({
            duration: 5000,
            title: "Error al intentar iniciar sesión",
            position: "bottom-center",
            color: "error",
          })

          // setError(true);
          console.error(e);

        })
    });

  }



  //   return (
  //     <div className="container-fluid">
  //       <section className="login">
  //         <div className="row">

  //           <div className="col-sm-12  col-lg-3">
  //             <div className="form-wp">
  //               <LoginForm access={access} loadingButton={loadingButton} />
  //             </div>
  //             {error && <div className="" role="alert"> Error al iniciar sesión </div>}
  //           </div>
  // {/* 
  //           <div className="col-sm-12 col-lg-9 px-0 login-right">
  //             <div className="login-right_image"></div>
  //           </div> */}
  //         </div>

  //       </section>
  //     </div>
  //   )

  return (
    <div className={`overflow-hidden flex justify-center items-center min-h-screen ${image ? 'login-background' : 'bg-[#22272e]'}`}>
      <div className="flex flex-col justify-center items-center bg-[#22272e]">

        <div className='mb-2 invert'>
          {logoAPP && (
            // invert width={230} height={10}
            <img className="sidebar-brand-full" src={logoAPP} alt="logo company" width={280} height={10} />
          )}
        </div>

        <div className="w-full px-4 sm:px-0">
          <div className={clsx(`flex flex-col items-center justify-around bg-white shadow-md rounded px-8 pt-4 pb-8  mb-24 min-h-[300px]`, {
            'min-h-[400px]': logoAPP
          })}>

            <div className='w-full mb-4'>
              <div className=' flex justify-start text-3xl'>
                Iniciar sesión
              </div>
              <div className=''>
                <Divider color='#aeaeae' marginX={-32} />
              </div>
            </div>



            <LoginForm access={access} loadingButton={loadingButton} />
            {error && <div className="text-red-500 text-sm mt-6" role="alert">* Error al intentar iniciar sesión</div>}
          </div>
        </div>


        {/* <div
          className='mt-10'
          style={{
            textAlign: 'center',
            color: "#fff",
            fontSize: 15,
     
            cursor: 'pointer',
            textDecoration: 'none'
          }}
          onClick={() => navigate('/registro')}
        >

          <div className='hover:underline'>
            <span>
              ¿No tienes cuenta? Regístrate aquí
            </span>

          </div>
        </div> */}
      </div>

    </div>
  )
}

export default LoginPage;